<template>
	<div class="vx-card p-6">
		<vs-row vs-w="12">
			<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
				<div class="mb-2" style="border: 1px solid #e4e4e4; border-radius: 10px">
					<floating-buttons
						:titleHeader="$t('BreakTable.Action')"
						:saveText="isEditActive ? SubmitButtonTitleEdit : SubmitButtonTitleCreate"
						:cancelText="$t('MODULE_PERMISSION.Cancel')"
						@save="submitForm"
						@cancel="cancel"
					/>
				</div>
				<form id="capacity-with-loading" class="vs-con-loading__container">
					<div class="vx-row p-2">
						<div class="vx-col w-full">
							<vx-card no-shadow card-border>
								<div class="vx-row p-2">
									<div class="vx-col md:w-1/2 w-full">
										<vs-input
											name="name"
											class="w-full"
											:label="$t('BreakTable.Name')"
											v-model="capacityItem.name"
											v-validate="'required|max:50'"
										/>
										<vs-input v-show="1 == 2" />
										<span class="text-danger text-sm" v-show="errors.has('name')">{{
											errors.first("name") !== undefined
												? $t(`VValidateMessage.${errors.first("name")}`)
												: ""
										}}</span>
									</div>
									<div class="vx-col md:w-1/2 w-full">
										<small>{{ $t("BreakTable.Description") }}</small>
										<vs-input
											name="description"
											class="w-full"
											v-model="capacityItem.description"
											v-validate="'max:150'"
										/>
										<span class="text-danger text-sm" v-show="errors.has('description')">{{
											errors.first("description") !== undefined
												? $t(`VValidateMessage.${errors.first("description")}`)
												: ""
										}}</span>
									</div>
								</div>
							</vx-card>
						</div>
					</div>
					<vx-card class="mt-2" :cardBorder="true" :noShadow="true">
						<div class="vx-row p-2">
							<div class="vx-col w-full md:w-1/2 sm:w-1/1">
								<vs-divider style="font-size: 14px; font-weight: bold">{{
									$t("Routing.Buttons.AddVisitPoint")
								}}</vs-divider>
								<assigned-visit-point-list
									:isDemand="true"
									:isTypeService="true"
									:capacities="
										isEditActive && capacityItem.visit_points ? capacityItem.visit_points : []
									"
								></assigned-visit-point-list>
							</div>
							<div class="vx-col w-full md:w-1/2 sm:w-1/1">
								<vs-divider style="font-size: 14px; font-weight: bold">{{
									$t("VisitPoints.Add") + " " + $t("Vehicles.Vehicles")
								}}</vs-divider>
								<vehicle-assigned-list
									:isDemand="true"
									:capacitiesVehicle="
										isEditActive && capacityItem.vehicles ? capacityItem.vehicles : []
									"
									:search="true"
									:pagination="true"
									:componentParent="'CAPACITY'"
								></vehicle-assigned-list>
							</div>
						</div>
					</vx-card>
				</form>
			</vs-col>
		</vs-row>
	</div>
</template>
<script>
import DateUtils from "@/helpers/DateUtils.js";
import AssignedVisitPointList from "../visit-point/list/AssignedVisitPointList.vue";
import windowScrollPosition from "@/plugins/window-scroll-position.js";
import moduleCapacity from "@/store/capacity/moduleCapacity.js";
import Capacity from "@/models/Capacity";
import FloatingButtons from "@/views/FloatingButtons.vue";
import VehicleAssignedList from "@/components/vehicle/list/VehicleAssignedList.vue";

export default {
	components: {AssignedVisitPointList, FloatingButtons, VehicleAssignedList},
	name: "CreateCapacity",
	props: {
		isEditActive: {
			type: Boolean,
			required: false,
		},
		dataCapacity: {
			type: Object,
		},
	},
	mixins: [windowScrollPosition("position")],
	data() {
		return {
			capacityItem: new Capacity({}),
			SubmitButtonTitle: "",
		};
	},
	created() {
		if (!moduleCapacity.isRegistered) {
			this.$store.registerModule("moduleCapacity", moduleCapacity);
			moduleCapacity.isRegistered = true;
		}
	},
	mounted() {
		if (this.isEditActive) {
			this.getCapacity();
		}
	},
	computed: {
		title() {
			return this.$t("Capacity.Capacity");
		},
		SubmitButtonTitleCreate() {
			return this.$t("Save");
		},
		SubmitButtonTitleEdit() {
			return this.$t("Crud.Update");
		},
		isScrolling() {
			return this.position[1] > 30;
		},
	},
	methods: {
		cancel() {
			this.$router.push({name: "CapacityList"});
		},
		formatDates(dateString) {
			const newDate = new Date(dateString);
			return DateUtils.toDefaultDateTime(newDate, "HH:MM:SS");
		},
		submitForm() {
			this.$vs.loading();
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (this.isEditActive) {
						this.updateData();
					} else {
						this.saveData();
					}
				} else {
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorFields.Title"),
						text: this.$t("ErrorFields.Text"),
					});
					this.$vs.loading.close();
				}
			});
		},
		saveData() {
			let params = {};
			delete this.capacityItem.id;
			this.capacityItem["visit_points"] =
				this.$store.state.moduleVisitPoint.assignedVisitPoints.map((visitPoint) => {
					let jobType;
					if (visitPoint.typeService === "DELIVERY") {
						jobType = "DELIVERY";
					} else if (visitPoint.typeService === "PICKUP") {
						jobType = "PICKUP";
					} else if (visitPoint.typeService === this.$t("DELIVERY")) {
						jobType = "DELIVERY";
					} else if (visitPoint.typeService === this.$t("PICKUP")) {
						jobType = "PICKUP";
					} else {
						jobType = visitPoint.typeService.value;
					}
					return {
						visit_point_id: visitPoint.id,
						amount: parseInt(visitPoint.demand),
						job_type: jobType,
					};
				}) || [];
			this.capacityItem["vehicles"] =
				this.$store.state.vehicle.assignedVehicles.length > 0
					? this.$store.state.vehicle.assignedVehicles.map((vehicle) => ({
							vehicle_id: vehicle.id,
							amount: parseInt(vehicle.demand),
					  })) || []
					: [];
			params = {...this.capacityItem};
			this.$store
				.dispatch("moduleCapacity/save", params)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Capacity.Messages.TitleConfirmCreate"),
						text: this.$t("Capacity.Messages.TextConfirmCreate"),
					});
					this.$vs.loading.close();
					this.$router.push({name: "CapacityList"});
					return res;
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "warning",
						title: this.$t("ErrorTitle"),
						text: this.$t("ErrorMessage"),
					});
					console.error(err);
				});
		},
		updateData() {
			this.capacityItem["visit_points"] = this.$store.state.moduleVisitPoint.assignedVisitPoints.map(
				(visitPoint) => {
					let jobType;
					if (visitPoint.typeService === "DELIVERY") {
						jobType = "DELIVERY";
					} else if (visitPoint.typeService === "PICKUP") {
						jobType = "PICKUP";
					} else if (visitPoint.typeService === this.$t("DELIVERY")) {
						jobType = "DELIVERY";
					} else if (visitPoint.typeService === this.$t("PICKUP")) {
						jobType = "PICKUP";
					} else {
						jobType = visitPoint.typeService.value;
					}
					return {
						visit_point_id: visitPoint.id,
						amount: parseInt(visitPoint.demand),
						job_type: jobType,
					};
				}
			);
			this.capacityItem["vehicles"] =
				this.$store.state.vehicle.assignedVehicles.length > 0
					? this.$store.state.vehicle.assignedVehicles.map((vehicle) => ({
							vehicle_id: vehicle.id,
							amount: parseInt(vehicle.demand),
					  })) || []
					: [];
			const params = {
				name: this.capacityItem.name,
				description: this.capacityItem.description,
				visit_points: this.capacityItem.visit_points,
				vehicles: this.capacityItem.vehicles,
			};
			this.$store
				.dispatch("moduleCapacity/update", {id: this.capacityItem.id, params})
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Capacity.Messages.TitleConfirmUpdate"),
						text: this.$t("Capacity.Messages.TextConfirmUpdate"),
					});
					this.$vs.loading.close();
					this.$router.push({name: "CapacityList"});
					return res;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		getCapacity() {
			this.$vs.loading({
				container: "#capacity-with-loading",
				scale: 1,
				type: "sound",
			});
			this.$store
				.dispatch("moduleCapacity/findCapacityFilter", {id: [parseInt(this.$route.params.id)]})
				.then((res) => {
					this.capacityItem = res.records[0];
					if (this.isEditActive) {
						let visitPointIds =
							res.records[0].hasOwnProperty("visit_points") && res.records[0]["visit_points"] !== null
								? res.records[0]["visit_points"].map(({visit_point_id}) => visit_point_id)
								: [];
						let vehicleIds =
							res.records[0].hasOwnProperty("vehicles") && res.records[0]["vehicles"] !== null
								? res.records[0]["vehicles"].map(({vehicle_id}) => vehicle_id)
								: [];
						if (visitPointIds && visitPointIds.length > 0) this.getVisitPoint(visitPointIds);
						if (vehicleIds && vehicleIds.length > 0) this.getAssignedVehicles(vehicleIds);
					}
					this.$vs.loading.close("#capacity-with-loading > .con-vs-loading");
					return res.records;
				})
				.catch((err) => {
					this.$vs.loading.close("#capacity-with-loading > .con-vs-loading");
					console.error(err);
				});
		},
		getAssignedVehicles(vehicleIds) {
			const data = {
				id: vehicleIds.map((id) => Number(id)),
				fields: ["id", "identification"],
				assign: true,
			};
			this.$store
				.dispatch("vehicle/findVehiclePaginated", data)
				.then((res) => {
					return res;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		getVisitPoint(visitPointIds) {
			this.$store
				.dispatch("moduleVisitPoint/findVisitPointsAssigned", {
					order_by: ["id"],
					sort: "desc",
					id: visitPointIds,
				})
				.then((res) => {
					return res;
				})
				.catch((err) => {
					console.error(err);
				});
		},
	},
	beforeDestroy() {
		this.$store.commit("moduleVisitPoint/REMOVE_ALL_ASSIGNED_VISIT_POINT");
		this.$store.commit("vehicle/REMOVE_ALL_ASSIGNED_VEHICLE");
	},
};
</script>
